"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCSSVariableTheme = void 0;
var addExtraThemeEntries_1 = require("./addExtraThemeEntries");
var cssVariables_1 = require("./cssVariables");
var mapLeafsOfObject_1 = require("./mapLeafsOfObject");
/**
 * This function could use a new name during a breaking change
 *
 * Given a Theme (which is the source of truth and doesn't contain any computed properties), add extra necessary properties to the tree such as `-rgb` suffixed keys with R, G, B triple values, and
 * convert the leaf values of a theme to a value like `var(--parent1key-parent2key-leafkey)` - a CSS variable with an identifier that represents it's hierarchy.
 *
 * Example:
 * ```
 * {
 *    color: {
 *        purple: {
 *          100: "#f0f1f4"
 *        }
 *    }
 * }
 * ```
 * Transforms into:
 * ```
 * {
 *    color: {
 *        purple: {
 *          100: "var(--color-purple-100, "#f0f1f4")",
 *          "100-rgb": "var(--color-purple-100-rgb, 240, 241, 244)",
 *          "100-id": "--color-purple-100",
 *          "100-rgb-id": "--color-purple-100-rgb"
 *        }
 *    }
 * }
 * ```
 *
 * See {@link addExtraThemeEntries} for how these extra entries are added.
 */
function makeCSSVariableTheme(theme, printValue) {
    if (printValue === void 0) { printValue = cssVariables_1.objectPathToCssVarFunction; }
    var augmentedTheme = {};
    var mapper = function (leafPath, value) {
        var leafKey = leafPath[leafPath.length - 1];
        var pathWithoutLast = leafPath.slice(0, leafPath.length - 1);
        var leafObject = pathWithoutLast.reduce(function (child, segment) {
            return (child[segment] || (child[segment] = {}));
        }, augmentedTheme);
        if (!leafKey) {
            throw new Error("leafKey is undefined");
        }
        var cssVariablesOfToken = (0, addExtraThemeEntries_1.addExtraThemeEntries)(leafPath, leafKey, value, printValue, { augmentWithId: true });
        Object.assign(leafObject, cssVariablesOfToken);
    };
    (0, mapLeafsOfObject_1.mapLeafsOfObject)(theme, mapper);
    return augmentedTheme;
}
exports.makeCSSVariableTheme = makeCSSVariableTheme;
//# sourceMappingURL=makeCssVariableTheme.js.map